export const knowledgeBaseData = [
    {
      id: 1,
      title: "Any other legal pages I should know about?",
      knowledgeList: [
        {
          text: "Policies have wide acceptance among editors",
          fileTextIcon: true,
        },
        {
          text: "Guidelines are sets of best practices supported.",
          badge: "New",
          fileTextIcon: true,
        },
        {
          fileTextIcon: true,
          text: "Editors should attempt to follow guidelines.",
        },
        {
          fileTextIcon: true,
          text: "They are best treated with common sense.",
        },
        {
          text: "See More (40)",
        },
      ],
    },
    {
      id: 2,
      title: "Does Moment have an API or automatic export?",
      knowledgeList: [
        {
          text: "Resource API content produced by business.",
          fileTextIcon: true,
          badge: "Review",
        },
        {
          fileTextIcon: true,
          text: "API allows the search and download of AP Images.",
        },
        {
          fileTextIcon: true,
          text: "API retrieve a list of breaking news categories",
          badge: "Articles",
        },
        {
          fileTextIcon: true,
          text: "API retrieves rules for a fantasy league.",
        },
        {
          text: "See More (90)",
        },
      ],
    },
    {
      id: 3,
      title: "WordPress Site Maintenance",
      knowledgeList: [
        {
          fileTextIcon: true,
          text: "Make a backup of your WordPress website.",
        },
        {
          fileTextIcon: true,
          text: "Run a security check.",
          badge: "Closed",
        },
        {
          fileTextIcon: true,
          text: "Monitor your search engine optimization.",
        },
        {
          fileTextIcon: true,
          text: "Set a regular maintenance schedule.",
        },
        {
          text: "See More (50)",
        },
      ],
    },
    {
      id: 4,
      title: "Can I change my plan later?",
      knowledgeList: [
        {
          text: "You can easily change plans Wonderfull at any time.",
          fileTextIcon: true,
          badge: "Popular",
        },
        {
          fileTextIcon: true,
          text: "you’ll be charged a prorated cover that upgrade.",
        },
        {
          fileTextIcon: true,
          text: "Sed quia non numquam eius modi tempora incidunt",
        },
        {
          fileTextIcon: true,
          text: "But also the leap into electronic typesetting,",
        },
        {
          text: "See More (90)",
        },
      ],
    },
    {
      id: 5,
      title: "How do I pay for the Premium Plan?",
      knowledgeList: [
        {
          text: "Premium plans are billed as a yearly payment.",
          fileTextIcon: true,
        },
        {
          text: "Etraset sheets containing Lorem Ipsum passages",
          fileTextIcon: true,
        },
        {
          text: "You can set Monthly or Yearly for Premium plan.",
          fileTextIcon: true,
        },
        {
          fileTextIcon: true,
          text: "When an unknown printer took a galley",
          badge: "Closed",
        },
        {
          text: "See More (50)",
        },
      ],
    },
    {
      id: 6,
      title: "What is your Shopping Policy",
      knowledgeList: [
        {
          fileTextIcon: true,
          text: "Many new editors rely on policy interpretations.",
        },
        {
          fileTextIcon: true,
          text: "It has a more-or-less normal distribution of letters",
        },
        {
          text: "Violation of maintaining a neutral point of view.",
          fileTextIcon: true,
          badge: "Article",
        },
        {
          fileTextIcon: true,
          text: "You double check your sources.",
        },
        {
          text: "See More (26)",
        },
      ],
    },
    {
      id: 7,
      title: "Validating a Website",
      knowledgeList: [
        {
          text: "When our power of choice is untrammelled",
          fileTextIcon: true,
          badge: "Review",
        },
        {
          fileTextIcon: true,
          text: "It will frequently occur that pleasures",
        },
        {
          text: "who fail in their duty through weakness",
          fileTextIcon: true,
          badge: "Closed",
        },
        {
          fileTextIcon: true,
          text: " At vero eos et accusamus et iusto",
        },
        {
          text: "See More (10)",
        },
      ],
    },
    {
      id: 8,
      title: "How can I change the component?",
      knowledgeList: [
        {
          fileTextIcon: true,
          text: "You can modify some specific component settings.",
        },
        {
          text: "Click Apply to validate the set preferences.",
          fileTextIcon: true,
          badge: "Popular",
        },
        {
          text: "Following procedure applie to external components",
          fileTextIcon: true,
          badge: "Review",
        },
        {
          text: "To modify those specific components settings.",
          fileTextIcon: true,
        },
        {
          text: "See More (21)",
        },
      ],
    },
    {
      id: 9,
      title: "What is Lorem Ipsum?",
      knowledgeList: [
        {
          text: "Common language regular the existing languages.",
          fileTextIcon: true,
        },
        {
          text: "Lorem Ipsum been industry's standard dummy",
          fileTextIcon: true,
        },
        {
          text: "Language is not real even ‘Lorem’ does't exist.",
          fileTextIcon: true,
        },
        {
          text: "dummy text that is not meant to mean anything.",
          badge: "On hold",
          fileTextIcon: true,
        },
        {
          text: "See More (34)",
        },
      ],
    },
  ];
